import { FC, memo } from 'react';

import { FallbackedLayout } from '@/common/layouts';

import { useGetComponentsPageQuery } from '@/modules/Pages';

import { PageComponentsOverviewView } from './PageComponentsOverviewView';

interface Props {
  siteId: string;
}

export const PageComponentsOverviewContainer: FC<Props> = memo(({ siteId }) => {
  const { data, isLoading, isError, error } = useGetComponentsPageQuery(siteId)({
    enabled: !!siteId
  });

  return (
    <FallbackedLayout data={ data } error={ error } isError={ isError } isLoading={ isLoading }>
      {
        (componentsList) => (
          <PageComponentsOverviewView
            items={ componentsList }
          />
        )
      }
    </FallbackedLayout>
  );
});
